/** Slugs que nunca podem virar subdomínio de clínica (colidem com hosts da plataforma). */
export const RESERVED_SLUGS = new Set([
    'www', 'api', 'app', 'admin', 'console', 'capilar', 'site', 'blog', 'painel', 'status', 'mail', 'smtp', 'cdn', 'static',
    'custom', 'webhooks', 'evo', 'grafana', 'auth', 'docs', 'suporte', 'help', 'dev',
    'staging', 'hml', 'teste', 'demo',
]);
export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{1,30}[a-z0-9])$/;
export function validateSlug(slug) {
    if (!SLUG_PATTERN.test(slug))
        return { ok: false, reason: 'format' };
    if (slug.includes('--'))
        return { ok: false, reason: 'double_hyphen' };
    if (RESERVED_SLUGS.has(slug))
        return { ok: false, reason: 'reserved' };
    return { ok: true };
}
/** Gera um slug a partir do nome fantasia: sem acento, minúsculo, hífens simples, máx. 32. */
export function slugify(name) {
    return name
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/-{2,}/g, '-')
        .replace(/^-|-$/g, '')
        .slice(0, 32)
        .replace(/-$/, '');
}
//# sourceMappingURL=slug.js.map